module.exports = __webpack_public_path__ + "static/media/video-play-file.6de48f7e.svg";